import {
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Box
} from "@mui/material";
import {
  FETCH_UD_FIELDS,
  SAVE_CLIENT_TIMESHEETS,
  FETCH_CLIENT_TIMESHEET_TEMPLATES_V2
} from "../../../constant/Apipath";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { Getrequestcall } from "../../../request/Getrequest";
import { Postrequestcall } from "../../../request/Postrequest";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect, useRef, useState } from "react";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import { CrewTimesheetForemanEntry } from "./CrewTimesheetForemanEntry";
import CrewTimesheetEmployeeClockInClockOut from "./CrewTimesheetEmployeeClockInClockOut";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import ClientTimesheetEmployeesModal from "../clientTimesheetEmployees/ClientTimesheetEmployeesModal";
import ClientTimesheetActivitiesModal from "../clientTimesheetActivities/ClientTimesheetActivitiesModal";
import Loader from "../../../common/Loader";
import SearchIcon from "@mui/icons-material/Search";
import SelectJob from "../clientTimesheetJobModel/SelectJob";
import { BIGrey } from "../../../assets/helpers";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";

let CLIENT_COLOR = "#000000";

const getudFieldsString = (data) => {
  try {
    if (!data?.length) return "";

    const fieldsObject = data.reduce((acc, item) => {
      acc[item.id] = item.fieldDefaultValue === "true" ? 1 : 0;
      return acc;
    }, {});

    return JSON.stringify(fieldsObject);
  } catch (error) {
    console.error("getudFieldsString-> Error processing UD fields:", error);
    return "";
  }
};

export default function ClientTimesheetCrewComponent({
  modelState,
  setModelState,
  handleClose,
  templateId,
  reloadData
}) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const TOKEN = loginData?.accessToken;
  CLIENT_COLOR = selectedClientData?.AccentColor;
  const USER_ID = loginData?.userInformation?.UserId;

  const [date, setDate] = useState(dayjs());
  const [manual, setManual] = useState(false);
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [isSwitchOn, setIsSwitchOn] = useState("manually");
  const [activityList, setActivityList] = useState([]);
  const [selectedValue, setSelectedValue] = useState({});

  const [employeesList, setEmployeesList] = useState([]);
  const [selectEmployees, setSelectEmployees] = useState(false);
  const [clientTimesheetId, setClienttimesheetId] = useState(0);
  const [selectActivities, setSelectActivities] = useState(false);

  const [openEmployee, setOpenemployee] = useState(true);
  const [openJob, setOpenjob] = useState(false);

  const [clockIn, setClockin] = useState(false);
  const [loader, setLoader] = useState(false);
  const [fromJob, setFromjob] = useState(false);
  const [fromActivity, setFromActivity] = useState(true);
  const [firstStep, setFirstStep] = useState(true);

  const {
    TEXT_DATE,
    TEXT_JOB,
    TEXT_SEARCH_JOB,
    TEXT_ACTIVITIES,
    TEXT_SELECT_ACTIVITIES,
    TEXT_EMPLOYEE,
    TEXT_SELECT_EMPLOYEES,
    TEXT_QUESTION_TIMESHEET,
    TEXT_MANUALLY_ENTER_HOURS,
    TEXT_EMPLOYEES_CLOCKIN_OUT,
    BUTTON_NEXT,
    TEXT_CREATE_NEW_TIMESHEET,
    TEXT_TODAY
  } = ClientEnglishFallback?.AddTimesheetModal(multiLanguageData?.AddTimesheetModal || {});

  const [forEditEmployees, setForEditEmployees] = useState({
    isEdit: false,
    data: {},
    form: "Crew"
  });
  const [forEditActivities, setForEditActivities] = useState({
    isEdit: false,
    data: {},
    form: "Crew"
  });

  useEffect(() => {
    const callInitialdata = async () => {
      setLoader(true);
      if (templateId === 0) {
        if (firstStep) {
          setFirstStep(false);
          setOpenjob(true);
        }
      }
      if (templateId !== 0) await getTemplateData();
      setLoader(false);
    };
    callInitialdata();
  }, [inputValue]);

  const getTemplateData = async () => {
    try {
      const fetchParams = {
        PageNr: 1,
        NrOfRecPerPage: 0,
        FullSearch: "",
        UserId: USER_ID,
        IncludeRecordNr: false,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            ClientEmployeeId: selectedClientData?.ClientEmployeeId,
            id: templateId
          }
        ]
      };
      const getResponse = await Postrequestcall(
        FETCH_CLIENT_TIMESHEET_TEMPLATES_V2,
        fetchParams,
        TOKEN
      );
      if (getResponse.status === 200) {
        let getData = getResponse?.data?.data[0] ?? [];
        let activityList = getData?.templateActivitiesList?.map((item) => {
          return {
            ...item,
            id: item?.activityId,
            labourActivityCode: item?.activityCode,
            labourActivityName: item?.activityName
          };
        });
        await fetchActivityFields(activityList);
        let employeeList = getData?.templateEmployeesList?.map((item) => {
          return {
            ...item,
            clientEmployeeUDFieldsList: item?.clientEmployeesUDFieldsList,
            id: item?.clientEmployeeId,
            clientEmployeeId: item?.clientEmployeeId,
            mileage: "",
            mileageUnit: "km",
            firstName: item?.clientEmployeeName
          };
        });
        setEmployeesList(employeeList);
        setInputValue(`${getData?.clientJobCode} - ${getData?.clientJobName} `);
        setSelectedValue({
          clientEmployeeId: selectedClientData?.ClientEmployeeId,
          clientJobCodeId: getData?.clientJobId
        });
      }
    } catch (error) {
      console.error("Error fetching timesheet templates:", error);
    } finally {
    }
  };

  // useEffect(() => {
  //   if (selectEmployees === false) {
  //     fetchEmployeeFields(employeesList);
  //   }
  // }, [selectEmployees]);

  // Get Employee UD Fields
  const fetchEmployeeFields = async (employeesList) => {
    try {
      let getList = await Promise.all(
        employeesList?.map(async (item) => {
          let getFields = await getUDfields(item?.id);
          if (getFields?.length > 0) {
            return {
              ...item,
              id: 0,
              mileage: "",
              mileageUnit: "km",
              udfields: getFields,
              clientEmployeeId: item?.id
            };
          } else {
            return {
              ...item,
              id: 0,
              mileage: "",
              mileageUnit: "km",
              udfields: [],
              clientEmployeeId: item?.id
            };
          }
        })
      );
      setEmployeesList(getList);
    } catch (error) {
      console.error("fetchEmployeeFields-> Error fetching fields:", error);
    }
  };

  const getUDfields = async (employeeId) => {
    let appId = 11;
    let clientId = selectedClientData?.ClientId;
    let entityRecordId = employeeId;
    let entityType = "Employee";
    try {
      let res = await Getrequestcall(
        `${FETCH_UD_FIELDS}${clientId}/${appId}/${entityRecordId}/${entityType}`,
        TOKEN
      );

      let getUdFieldsdata = res?.data?.data?.map((udFields) => {
        return {
          ...udFields,
          udFieldId: udFields.id,
          udFieldTypeName: udFields.udFieldTypeName,
          fieldLabel: udFields.fieldLabel,
          fieldDefaultValue: udFields.fieldDefaultValue,
          isChecked: udFields.fieldDefaultValue,
          checked: udFields.fieldDefaultValue === "true" ? true : false
        };
      });
      return getUdFieldsdata;
    } catch (error) {
      console.error("getUDfields Error ", error);
    }
  };

  useEffect(() => {
    if (selectActivities === false) {
      fetchActivityFields(activityList);
    }
  }, [selectActivities]);

  const fetchActivityFields = async (activityList) => {
    try {
      let getList = await Promise.all(
        activityList?.map(async (item) => {
          let getFields = await getActivityUdfields(item?.id);
          if (getFields?.length > 0) {
            return {
              ...item,
              udfields: getFields
            };
          } else {
            return {
              ...item,
              udfields: []
            };
          }
        })
      );
      setActivityList(getList);
    } catch (error) {
      console.error("fetchActivityFields-> Error fetching fields:", error);
    }
  };

  const getActivityUdfields = async (activityId) => {
    let appId = 11;
    let clientId = selectedClientData?.ClientId;
    let entityRecordId = activityId;
    let entityType = "Activity";
    try {
      let res = await Getrequestcall(
        `${FETCH_UD_FIELDS}${clientId}/${appId}/${entityRecordId}/${entityType}`,
        TOKEN
      );
      let getUdFieldsdata = res?.data?.data?.map((udFields) => {
        return {
          ...udFields,
          udFieldId: udFields.id,
          udFieldTypeName: udFields.udFieldTypeName,
          fieldLabel: udFields.fieldLabel,
          fieldDefaultValue: udFields.fieldDefaultValue,
          isChecked: udFields.fieldDefaultValue,
          checked: udFields.fieldDefaultValue === "true" ? true : false
        };
      });
      return getUdFieldsdata;
    } catch (error) {
      console.error("getActivityUdfields-> getUDfields Error ", error);
    }
  };

  const clearTheData = () => {
    setDate(dayjs());
    setSelectedValue({});
    setInputValue("");
    setSelectActivities(false);
    setSelectEmployees(false);
    setActivityList([]);
    setEmployeesList([]);
    setForEditEmployees({
      isEdit: false,
      data: {},
      form: "Crew"
    });
    setForEditActivities({
      isEdit: false,
      data: {},
      form: "Crew"
    });
  };

  const getActivityListForApi = async () => {
    try {
      const finalActivityData = activityList?.map((act, index) => {
        let udFieldJsonString = {};
        act.udfields.forEach((field) => {
          let isChecked = field.checked === true;
          if (isChecked) {
            udFieldJsonString[field.udFieldId] = 1;
          } else {
            udFieldJsonString[field.udFieldId] = 0;
          }
        });
        const udFieldsString = JSON.stringify(udFieldJsonString);
        return {
          Id: 0,
          ClientJobId: selectedValue?.clientJobCodeId,
          ClientActivityId: act?.id,
          Qty: 0,
          QtyUnit: act.quantityUnit,
          Notes: "",
          UDFields: udFieldsString,
          Deleted: false
        };
      });
      return finalActivityData;
    } catch (error) {
      console.log("getActivityListForApi-> Error Generating Get Activity List For Api: ", error);
    }
  };

  const getEmployeeListForApi = async () => {
    const employeeListData = employeesList?.map((emp, index) => {
      return {
        Id: 0,
        ClientJobId: selectedValue?.clientJobCodeId,
        ClientEmployeeId: emp?.clientEmployeeId,
        Mileage: emp?.mileage == "" ? 0 : emp?.mileage || 0,
        MileageUnit: emp?.mileageUnit || "km",
        UDFields: getudFieldsString(emp?.clientEmployeeUDFieldsList),
        Deleted: false
      };
    });
    return employeeListData;
  };

  const getTimesheetHoursListForApi = async () => {
    try {
      let hourList = activityList.flatMap((activities) => {
        let getItem = employeesList?.map((employee) => {
          return {
            Id: 0,
            ClientJobId: selectedValue?.clientJobCodeId,
            ClientEmployeeId: employee?.clientEmployeeId,
            ClientJobActivityId: activities.id,
            Hours: 0,
            Deleted: false,
            statusId: 4
          };
        });
        return getItem;
      });
      return hourList;
    } catch (error) {}
  };
  const getudFieldsString = (data) => {
    if (!data?.length) return "";

    const fieldsObject = data.reduce((acc, item) => {
      acc[item.id] = item.fieldDefaultValue === "true" ? 1 : 0;
      return acc;
    }, {});

    return JSON.stringify(fieldsObject);
  };
  const onNextPressed = async () => {
    try {
      const employeeList = await getEmployeeListForApi();
      const timesheetHoursList = await getTimesheetHoursListForApi();
      const activityList = await getActivityListForApi();

      const timeSheetJobList = [
        {
          Id: 0,
          ClientJobId: selectedValue.clientJobCodeId,
          Notes: "",
          UDFields: getudFieldsString(selectedValue?.clientJobUDFieldsList),
          Deleted: false
        }
      ];
      const timesheetObj = {
        UserId: USER_ID,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            Date: date,
            DateSubmitted: new Date(),
            StatusId: 4,
            TypeId: isSwitchOn === "clockinandout" ? 4 : 2,
            ClientId: selectedClientData?.ClientId,
            Deleted: false,
            TimeSheetJobList: timeSheetJobList,
            EmployeeList: employeeList,
            TimesheetHoursList: timesheetHoursList,
            ActivityList: activityList
          }
        ]
      };

      const getResponse = await Postrequestcall(
        SAVE_CLIENT_TIMESHEETS,
        timesheetObj,
        loginData?.accessToken
      );
      if (getResponse.status === 201) {
        let clientTimesheetId = getResponse?.data?.data?.[0]?.objData?.ClientTimesheetId ?? 0;
        if (isSwitchOn === "clockinandout") {
          setClockin(true);
          setManual(false);
        } else {
          setClockin(false);
          setManual(true);
        }
        setClienttimesheetId(clientTimesheetId);
      }
    } catch (error) {
    } finally {
    }
  };

  const returnSelectedemp = () => {
    let getList = employeesList?.map((item) => {
      return {
        ...item,
        id: item?.clientEmployeeId
      };
    });
    return getList;
  };

  const onEmployeeUdfieldchange = (e, emp, udField, from) => {
    let updatedList = employeesList?.map((item) => {
      if (item.clientEmployeeId === emp.clientEmployeeId) {
        let getUpdatedudfield = item.udfields?.map((ud) => {
          if (ud.id === udField.id) {
            return {
              ...ud,
              checked: ud.checked ? false : true
            };
          }
          return ud;
        });
        return {
          ...item,
          udfields: getUpdatedudfield
        };
      }
      return item;
    });
    setEmployeesList(updatedList);
  };

  const onActivityUdfieldchange = (e, act, udField, from) => {
    let updatedList = activityList?.map((item) => {
      if (item.id === act.id) {
        let getUpdatedudfield = item.udfields?.map((ud) => {
          if (ud.id === udField.id) {
            return {
              ...ud,
              checked: ud.checked ? false : true
            };
          }
          return ud;
        });
        return {
          ...item,
          udfields: getUpdatedudfield
        };
      }
      return item;
    });
    setActivityList(updatedList);
  };

  if (loader) {
    return <Loader />;
  }

  return (
    <>
      <Stack sx={{ display: "flex",  mb: 1,  justifyContent: "space-between", alignItems: "center" }}   direction={"row"}>
        {modelState == "HOME" && (
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
            {TEXT_CREATE_NEW_TIMESHEET}
          </Typography>
        )}
        {modelState != "HOME" && (
          <IconButton
            size="small"
            onClick={() => {
              clearTheData();
              setModelState("HOME");
            }}>
            <ArrowBackIcon />
          </IconButton>
        )}
        <IconButton
          onClick={() => {
            handleClose();
            clearTheData();
            setModelState("HOME");
          }}
          style={{ padding: "4px" }}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <Grid container spacing={1}>
        <Grid size={12}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Typography>{TEXT_DATE}</Typography>
            <Box
              onClick={() => setOpen(true)}
              sx={{
                height: "40px",
                backgroundColor: "#e4e4e4",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0 10px",
                cursor: "pointer"
              }}>
              <span>
                {date && dayjs.isDayjs(date)
                  ? dayjs(date).isSame(dayjs(), "day")
                    ? `${dayjs(date).format("MMM DD, YYYY")} (Today)`
                    : dayjs(date).format("MMM DD, YYYY")
                  : dayjs().format("MMM DD, YYYY")}
              </span>
              <InsertInvitationIcon
                sx={{
                  color: selectedClientData?.AccentColor,
                  cursor: "pointer"
                }}
              />
            </Box>
            <MobileDatePicker
              open={open}
              onOpen={() => setOpen(true)}
              onClose={() => setOpen(false)}
              format="MMM DD, YYYY"
              value={date}
              onChange={(newValue) => setDate(newValue)}
              defaultValue={dayjs()}
              sx={{ display: "none" }} // Hide the actual picker input
            />
          </LocalizationProvider>
        </Grid>
        <Grid size={12}>
          <Typography sx={{ margin: 0 }} variant="subtitle1" gutterBottom>
            {TEXT_JOB}
          </Typography>
          <TextField
            placeholder={TEXT_SEARCH_JOB}
            size="small"
            sx={{
              backgroundColor: "#e4e4e4",
              borderRadius: "10px",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none"
              }
            }}
            slotProps={{
              input: {
                readOnly: true,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }
            }}
            value={inputValue}
            fullWidth
            variant="outlined"
            onClick={() => {
              setOpenjob(true);
            }}
          />
        </Grid>
        <Grid
          container
          size={12}
          sx={{
            maxHeight: "400px",
            overflow: "scroll",
            scrollbarWidth: "none"
          }}>
          <Grid size={12}>
            <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction="row">
              <Typography sx={{ fontWeight: "bold" }}>{TEXT_ACTIVITIES}</Typography>
              {activityList?.length != 0 && (
                <Typography
                  onClick={() => {
                    if (
                      selectedValue?.clientJobCodeId !== 0 &&
                      typeof selectedValue?.clientJobCodeId !== "undefined"
                    ) {
                      setFromjob(false);
                      setSelectActivities(true);
                    } else {
                      alert("Select a Job");
                      setOpenjob(true);
                    }
                    setFromActivity(false);
                  }}
                  sx={{
                    cursor: "pointer",
                    color: CLIENT_COLOR
                  }}>
                  {TEXT_SELECT_ACTIVITIES}
                </Typography>
              )}
            </Stack>
            {activityList?.length == 0 && (
              <Button
                fullWidth
                onClick={() => {
                  if (
                    selectedValue?.clientJobCodeId !== 0 &&
                    typeof selectedValue?.clientJobCodeId !== "undefined"
                  ) {
                    setFromjob(false);
                    setSelectActivities(true);
                  } else {
                    alert("Select a Job");
                    setOpenjob(true);
                  }
                  setFromActivity(false);
                }}
                sx={{
                  backgroundColor: CLIENT_COLOR,
                  color: "white",
                  borderRadius: "10px",
                  textTransform: "none"
                }}>
                {TEXT_SELECT_ACTIVITIES}
              </Button>
            )}
            <Grid sx={{ mt: 1 }} container spacing={1}>
              {activityList?.map((item, index) => {
                return (
                  <ListingComponent
                    from={"activityList"}
                    activityList={activityList}
                    setActivityList={setActivityList}
                    key={index}
                    item={item}
                    index={index}
                    onActivityUdfieldchange={onActivityUdfieldchange}
                  />
                );
              })}
            </Grid>
          </Grid>
          <Grid size={12}>
            <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction="row">
              <Typography sx={{ fontWeight: "bold" }}>{TEXT_EMPLOYEE}</Typography>
              {employeesList?.length != 0 && (
                <Typography
                  onClick={() => {
                    setFromActivity(false);
                    setSelectEmployees(true);
                  }}
                  sx={{
                    cursor: "pointer",
                    color: CLIENT_COLOR,
                    marginTop: "10px"
                  }}>
                  {TEXT_SELECT_EMPLOYEES}
                </Typography>
              )}
            </Stack>
            {employeesList?.length == 0 && (
              <Button
                fullWidth
                onClick={() => {
                  setFromActivity(false);
                  setSelectEmployees(true);
                }}
                sx={{
                  backgroundColor: CLIENT_COLOR,
                  color: "white",
                  borderRadius: "10px",
                  textTransform: "none"
                }}>
                {TEXT_SELECT_EMPLOYEES}
              </Button>
            )}
            <Grid sx={{ mt: 1 }} container spacing={1}>
              {employeesList?.map((item, index) => {
                return (
                  <ListingComponent
                    from={"employeeList"}
                    employeesList={employeesList}
                    setEmployeesList={setEmployeesList}
                    key={index}
                    item={item}
                    index={index}
                    onEmployeeUdfieldchange={onEmployeeUdfieldchange}
                  />
                );
              })}
            </Grid>
            <Stack sx={{ justifyContent: "space-between", alignItems: "center", marginTop: "10px" }} direction={"row"}>
              <FormControl>
                <FormLabel color={BIGrey}>{TEXT_QUESTION_TIMESHEET}</FormLabel>
                <RadioGroup
                  value={isSwitchOn}
                  onChange={(e) => {
                    setIsSwitchOn(e.target.value);
                  }}
                  sx={{
                    padding: "10px"
                  }}>
                  <FormControlLabel
                    value="manually"
                    checked={isSwitchOn === "manually" ? true : false}
                    defaultChecked={true}
                    control={
                      <Radio
                        sx={{
                          "&.Mui-checked": {
                            color: CLIENT_COLOR
                          }
                        }}
                      />
                    }
                    label={TEXT_MANUALLY_ENTER_HOURS}
                  />
                  <FormControlLabel
                    value="clockinandout"
                    checked={isSwitchOn === "clockinandout" ? true : false}
                    control={
                      <Radio
                        sx={{
                          "&.Mui-checked": {
                            color: CLIENT_COLOR
                          }
                        }}
                      />
                    }
                    label={TEXT_EMPLOYEES_CLOCKIN_OUT}
                  />
                </RadioGroup>
              </FormControl>
            </Stack>
          </Grid>
        </Grid>

        <Button
          fullWidth
          onClick={() => onNextPressed()}
          disabled={
            selectedValue?.clientJobCodeId === 0 ||
            employeesList?.length === 0 ||
            activityList?.length === 0
              ? true
              : false
          }
          sx={{
            backgroundColor:
              selectedValue?.clientJobCodeId === 0 ||
              employeesList?.length === 0 ||
              activityList?.length === 0
                ? "lightgrey"
                : CLIENT_COLOR,
            color: "white",
            borderRadius: "10px",
            textTransform: "none"
          }}>
          {BUTTON_NEXT}
        </Button>
      </Grid>

      {openJob && (
        <SelectJob
          isOpen={openJob}
          onClose={() => setOpenjob(false)}
          setInputValue={setInputValue}
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
          setSelectActivities={setSelectActivities}
          setFromjob={setFromjob}
        />
      )}

      {manual && (
        <CrewTimesheetForemanEntry
          isOpen={manual}
          onClose={() => {
            setModelState("HOME");
            handleClose();
            clearTheData();
            reloadData();
          }}
          clientTimesheetId={clientTimesheetId}
        />
      )}

      {clockIn && (
        <CrewTimesheetEmployeeClockInClockOut
          isOpen={clockIn}
          clientTimesheetId={clientTimesheetId}
          onClose={() => {
            setModelState("HOME");
            handleClose();
            clearTheData();
            reloadData();
          }}
        />
      )}

      {selectEmployees && (
        <ClientTimesheetEmployeesModal
          setSelectedEmp={setEmployeesList}
          empList={returnSelectedemp()}
          isEditdetails={forEditEmployees}
          isOpen={selectEmployees}
          setSelectEmployees={setSelectEmployees}
          onClose={
            fromActivity
              ? () => {
                  setSelectActivities(true);
                  setSelectEmployees(false);
                }
              : () => {
                  setSelectEmployees(false);
                }
          }
        />
      )}

      {selectActivities && (
        <ClientTimesheetActivitiesModal
          setSelectedActivityList={setActivityList}
          isEditdetails={forEditActivities}
          isOpen={selectActivities}
          onClose={() => setSelectActivities(false)}
          jobId={selectedValue?.clientJobCodeId}
          actList={activityList}
          fromJob={fromJob}
          setOpenjob={setOpenjob}
          openEmployee={openEmployee}
          setOpenemployee={setOpenemployee}
          setSelectEmployees={setSelectEmployees}
        />
      )}
    </>
  );
}

const ListingComponent = ({
  item,
  employeesList,
  setEmployeesList,
  activityList,
  setActivityList,
  index,
  from
}) => {
  const deleteEmployee = (getItem) => {
    if (from === "employeeList") {
      let getUpdatelist = employeesList?.filter(
        (item) => item?.clientEmployeeId !== getItem?.clientEmployeeId
      );
      setEmployeesList(getUpdatelist);
    } else {
      let getUpdatelist = activityList?.filter((item) => item?.id !== getItem?.id);
      setActivityList(getUpdatelist);
    }
  };

  return (
    <Grid
      size={12}
      spacing={1}
      sx={{
        border: "1px solid #e4e4e4",
        padding: "10px",
        borderRadius: "15px",
        cursor: "pointer"
      }}
      container
      key={index}
      style={{ display: "flex", justifyContent: "space-between" }}>
      <Grid size={12}>
        <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"} width={"100%"}>
          <Typography
            sx={{
              wordBreak: "break-all",
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 1,
              fontSize: "17px",
              fontWeight: "bold"
            }}>
            {from === "employeeList"
              ? item?.firstName + " " + (item?.lastName ? item?.lastName : "")
              : item?.labourActivityCode + " " + item.labourActivityName}
          </Typography>
          <IconButton size="small" onClick={() => deleteEmployee(item)}>
            <CloseIcon
              sx={{
                color: CLIENT_COLOR
              }}
            />
          </IconButton>
        </Stack>
      </Grid>
      {/* <Grid size={12}>
        {item?.udfields?.map((udField) => (
          <FormControlLabel
            control={
              <Checkbox
                checked={udField?.checked}
                sx={{
                  color: CLIENT_COLOR,
                  "&.Mui-checked": {
                    color: CLIENT_COLOR
                  }
                }}
                onChange={
                  from === "employeeList"
                    ? (e) => onEmployeeUdfieldchange(e, item, udField, from)
                    : (e) => onActivityUdfieldchange(e, item, udField, from)
                }
              />
            }
            label={udField?.fieldLabel}
          />
        ))}
      </Grid> */}
    </Grid>
  );
};
